import { useQuery } from "@tanstack/react-query";
import { GroupSessionDetail } from "@/pages/app/provider/scheduling/group-appointment";
import { GroupVisitSessionControllerApi } from "@/services";
import { getConfigObject, getXtenantId } from "@/utils/utils";

export const GROUP_SESSION_DETAIL_QUERY_KEY = "group-session-detail";

export const useGroupSessionById = (sessionId?: string) =>
  useQuery({
    queryKey: [GROUP_SESSION_DETAIL_QUERY_KEY, sessionId],
    enabled: !!sessionId,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new GroupVisitSessionControllerApi(getConfigObject())
        .getSessionById(sessionId as string, getXtenantId())
        .then((res) => res?.data?.data as GroupSessionDetail),
  });
